import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormGroupDirective, NgModel, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { FiscalYear } from '../../../models/shared-component/fiscal-year';
import { ShareService } from '../../../services/shared.service';

@Component({
  selector: 'fiscal-year-selector',
  templateUrl: './fiscal-year-selector.component.html',
  styleUrls: ['./fiscal-year-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: FiscalYearSelectorComponent
    }
  ]
})
export class FiscalYearSelectorComponent implements OnInit, ControlValueAccessor {
  constructor(
    public sharedService: ShareService,
  ) { }

  @ViewChild('fiscalYear') fiscalYearControl: NgModel; // Access ngModel in the template

  @Input() clearable: boolean = false;
  @Input() default: number;
  @Input() defaultDisabled: boolean;
  @Input() required: boolean = false;
  @Output() output = new EventEmitter<number>();

  fiscalYearId?: number;

  onChange = (fiscalYearId: number | undefined) => { };

  onTouched = () => { };

  touched = false;

  disabled = false;

  fiscalYear$ = new BehaviorSubject<FiscalYear[] | null>(null);

  ngOnInit(): void {
    if (this.default) {
      this.fiscalYearId = this.default;
    }
    if (this.defaultDisabled) {
      this.setDisabledState(true);
    }
    else {
      this.setDisabledState(false);
    }
    this.getFiscalYear();
  }

  writeValue(fiscalYearId: number): void {
    console.log(fiscalYearId);
    this.fiscalYearId = fiscalYearId;
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  async getFiscalYear(): Promise<void> {
    this.fiscalYear$.next(await firstValueFrom(this.sharedService.getFiscalYear()));
  }

  selectFiscalYear(fiscalYear: FiscalYear) {
    console.log(fiscalYear);
    this.markAsTouched();
    if (fiscalYear) {
      this.fiscalYearId = fiscalYear.id;
      this.onChange(this.fiscalYearId);
      this.output.emit(this.fiscalYearId);
    }
    else {
      this.fiscalYearId = undefined;
      this.onChange(this.fiscalYearId);
      this.output.emit(this.fiscalYearId);
    }
  }

  markAsForNgModelTouched() {
    if (this.fiscalYearControl && !this.fiscalYearControl.touched) {
      this.fiscalYearControl.control.markAsTouched();  // Mark the ngModel as touched
    }
  }
}
